import * as i0 from '@angular/core';
import * as i1 from './material-rules.module';
import * as i2 from '@angular/common';
import * as i3 from '@angular/cdk/bidi';
import * as i4 from '@angular/material/button';
import * as i5 from '@angular/cdk/scrolling';
import * as i6 from '@angular/material/core';
import * as i7 from '@angular/material/autocomplete';
import * as i8 from './ui/input/input.component';
import * as i9 from './ui/string/string.component';
import * as i10 from './ui/text-area/text-area.component';
import * as i11 from './ui/select/select.component';
import * as i12 from './ui/checkbox/checkbox.component';
import * as i13 from './ui/radio-group/radio-group.component';
import * as i14 from './ui/date-picker/date-picker.component';
import * as i15 from './ui/autocomplete/autocomplete.component';
import * as i16 from './ui/button/button.component';
import * as i17 from './metaui/meta-form/meta-form-group.component';
import * as i18 from './metaui/meta-form/form-field-adapter.directive';
import * as i19 from './metaui/meta-content-page/meta-content-page.component';
import * as i20 from './ui/ui.module';
import * as i21 from './metaui/meta-ui-layout.module';
export const MaterialRulesModuleNgFactory:i0.NgModuleFactory<i1.MaterialRulesModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any,any> = (<any>(null as any));
var _decl0_3:i2.NgIf<any> = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.Dir = (<any>(null as any));
var _decl0_12:i4.MatButton = (<any>(null as any));
var _decl0_13:i4.MatAnchor = (<any>(null as any));
var _decl0_14:i5.CdkScrollable = (<any>(null as any));
var _decl0_15:i6.MatOption = (<any>(null as any));
var _decl0_16:i6.MatOptgroup = (<any>(null as any));
var _decl0_17:i7.MatAutocomplete = (<any>(null as any));
var _decl0_18:i7.MatAutocompleteTrigger = (<any>(null as any));
var _decl0_19:i7.MatAutocompleteOrigin = (<any>(null as any));
var _decl0_20:i8.InputField = (<any>(null as any));
var _decl0_21:i9.StringField = (<any>(null as any));
var _decl0_22:i10.TextArea = (<any>(null as any));
var _decl0_23:i11.Select = (<any>(null as any));
var _decl0_24:i12.Checkbox = (<any>(null as any));
var _decl0_25:i13.RadioGroup = (<any>(null as any));
var _decl0_26:i14.DatePicker = (<any>(null as any));
var _decl0_27:i15.AutoComplete = (<any>(null as any));
var _decl0_28:i16.Button = (<any>(null as any));
var _decl0_29:i17.MetaFormGroup = (<any>(null as any));
var _decl0_30:i18.MetaFFAdapter = (<any>(null as any));
var _decl0_31:i19.MetaContentPageComponent = (<any>(null as any));
var _decl0_32:i2.AsyncPipe = (<any>(null as any));
var _decl0_33:i2.UpperCasePipe = (<any>(null as any));
var _decl0_34:i2.LowerCasePipe = (<any>(null as any));
var _decl0_35:i2.JsonPipe = (<any>(null as any));
var _decl0_36:i2.SlicePipe = (<any>(null as any));
var _decl0_37:i2.DecimalPipe = (<any>(null as any));
var _decl0_38:i2.PercentPipe = (<any>(null as any));
var _decl0_39:i2.TitleCasePipe = (<any>(null as any));
var _decl0_40:i2.CurrencyPipe = (<any>(null as any));
var _decl0_41:i2.DatePipe = (<any>(null as any));
var _decl0_42:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_43:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_44:i2.KeyValuePipe = (<any>(null as any));
var _decl0_45:i2.CommonModule = (<any>(null as any));
var _decl0_48:i20.UIModule = (<any>(null as any));
var _decl0_49:i21.LayoutModule = (<any>(null as any));
var _decl0_50:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_51:i0.ElementRef<any> = (<any>(null as any));
